export class Group {
  groupId: string;
  isManualMemberSelection: boolean;
  name: string;
  numberOfEmployees: number;
  numberOfManagers: number;
  hasManagePermission: boolean;
  hasViewPermission: boolean;
  isLinkedToLearnUpon: boolean;

  constructor(data: any) {
    this.groupId = data.groupId;
    this.isManualMemberSelection = data.isManualMemberSelection;
    this.name = data.name;
    this.numberOfEmployees = data.numberOfEmployees;
    this.numberOfManagers = data.numberOfManagers;
    this.numberOfManagers = data.numberOfManagers;
    this.hasManagePermission = data.hasManagePermission;
    this.hasViewPermission = data.hasViewPermission;
    this.isLinkedToLearnUpon = data.isLinkedToLearnUpon ?? false;
  }
}

/** Groups listed under My groups in the menu: LearnUpon-linked ones are hidden there, but stay reachable. */
export const getMyGroupsNavGroups = <T extends { isLinkedToLearnUpon?: boolean }>(
  groups: T[]
): T[] => groups.filter((group) => !group.isLinkedToLearnUpon);
